/**
 * NFeCartaCorrecaoModal Component
 * 
 * Modal para emissão de Carta de Correção Eletrônica (CCe) para NF-e autorizada.
 */

import { useState } from 'react'
import { FileText } from 'lucide-react'
import Modal from '../Modal/Modal'
import './NFeCartaCorrecaoModal.css'

function NFeCartaCorrecaoModal({ isOpen, onClose, onConfirm, nfe, loading = false }) {
  const [correcao, setCorrecao] = useState('')
  const [error, setError] = useState('')

  const handleConfirm = () => {
    // Validar correção
    if (!correcao || correcao.trim().length < 15) {
      setError('Texto da correção deve ter no mínimo 15 caracteres')
      return
    }

    setError('')
    onConfirm(correcao.trim())
  }

  const handleClose = () => {
    setCorrecao('')
    setError('')
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Emitir Carta de Correção Eletrônica (CCe)"
      size="medium"
    >
      <div className="nfe-carta-correcao-modal">
        <div className="cce-info">
          <FileText size={24} />
          <div>
            <h3>Informações</h3>
            <p>A Carta de Correção Eletrônica (CCe) permite corrigir informações da NF-e após sua autorização.</p>
            {nfe && (
              <p className="nfe-info">
                <strong>NF-e #{nfe.number}</strong> - Chave: {nfe.access_key?.substring(0, 20)}...
              </p>
            )}
          </div>
        </div>

        <div className="form-field">
          <label htmlFor="correcao">
            Texto da Correção <span className="required">*</span>
            <span className="char-count">
              ({correcao.length}/15 mínimo)
            </span>
          </label>
          <textarea
            id="correcao"
            value={correcao}
            onChange={(e) => {
              setCorrecao(e.target.value)
              setError('')
            }}
            placeholder="Digite o texto da correção (mínimo 15 caracteres)..."
            rows={5}
            className={error ? 'error' : ''}
            disabled={loading}
          />
          {error && <span className="error-message">{error}</span>}
          <p className="help-text">
            O texto da correção é obrigatório e deve ter no mínimo 15 caracteres conforme legislação.
          </p>
        </div>

        <div className="modal-footer">
          <button
            className="btn-secondary"
            onClick={handleClose}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            className="btn-primary"
            onClick={handleConfirm}
            disabled={loading || correcao.trim().length < 15}
          >
            {loading ? 'Emitindo...' : 'Emitir CCe'}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default NFeCartaCorrecaoModal
